import React, { useState, useEffect, useCallback } from 'react';
import { ProdutosServicos } from './ProdutosServicos/ProdutosServicos';
import { Movimentacoes } from './Movimentacoes/Movimentacoes';
import { NumberBox } from '../../../components/Editors/NumberBox';
import { DateBox } from '../../../components/Editors/DateBox';
import { TextBox } from '../../../components/Editors/TextBox';
import { Load, Save, Delete, Clone } from './utils/Grupo';
import './financeiro-documento.css';
import('./grid.css');

export const Grupo = ({
  grupoId,
  groupsLength,
  index,
  documentoId,
  refreshDocumentoGrupo,
  ocultarProdutosServicos,
  initialExpanded, // nova prop para determinar se o grupo vem expandido
}) => {
  const [emissaoValue, setEmissaoValue] = useState();
  const [referenciaAnoValue, setReferenciaAnoValue] = useState();
  const [referenciaMesValue, setReferenciaMesValue] = useState();
  const [observacaoValue, setObservacaoValue] = useState();
  const [isExpanded, setIsExpanded] = useState(initialExpanded);

  // Cria um handler genérico para atualização e salvamento dos campos
  const createOnChangeHandler = useCallback(
    (setter, field) => (value) => {
      setter(value);
      Save(field, value, grupoId);
    },
    [grupoId]
  );

  const onChangeEmissao = createOnChangeHandler(setEmissaoValue, 'emissao');
  const onChangeReferenciaAno = createOnChangeHandler(setReferenciaAnoValue, 'referencia_ano');
  const onChangeReferenciaMes = createOnChangeHandler(setReferenciaMesValue, 'referencia_mes');
  const onChangeObservacao = createOnChangeHandler(setObservacaoValue, 'observacao');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await Load(grupoId);
        setEmissaoValue(data.emissao);
        setReferenciaAnoValue(data.referencia_ano);
        setReferenciaMesValue(data.referencia_mes);
        setObservacaoValue(data.observacao);
      } catch (error) {
        console.error('Erro ao carregar dados do grupo:', error);
      }
    };
    fetchData();
  }, [grupoId]);

  const multipleGroups = groupsLength > 1;

  return (
    <div className="d-flex flex-column rounded mt-3 ">
      <div className="financeiro_documento_grupo_header_panel py-0 my-0 mb-2 d-flex justify-content-between align-items-center">
        <h3 className="fw-bold px-2 py-2 my-0">Grupo {index + 1}</h3>
        <button
          className="btn btn-sm text-secondary me-3"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? (
            <i className="far fa-window-minimize"></i>
          ) : (
            <i className="far fa-window-maximize"></i>
          )}
        </button>
      </div>

      {isExpanded && (
        <>
          <div className="d-sm-flex align-items-center fw-bold mx-0 pb-2">
            {!multipleGroups && (
              <div>
                <span className="fw-bold px-0 mx-2 theme-header-title">Grupo {index + 1}</span>|
              </div>
            )}

            <i
              type="button"
              className="fa-regular fa-clone mx-2"
              onClick={() => Clone(documentoId, grupoId, refreshDocumentoGrupo)}
            />

            <i
              type="button"
              className="fa-solid fa-trash-can mx-2"
              onClick={() => Delete(documentoId, grupoId, refreshDocumentoGrupo)}
            />

            <div className="d-flex">
              <NumberBox
                className="ms-2"
                label="Ano"
                stylingMode="outlined"
                onChange={onChangeReferenciaAno}
                value={referenciaAnoValue}
                min={2000}
                max={2100}
                width="100px"
                required={true}
              />
              <NumberBox
                className="ms-2"
                label="Mês"
                stylingMode="outlined"
                onChange={onChangeReferenciaMes}
                value={referenciaMesValue}
                min={1}
                max={12}
                format="00"
                width="80px"
                required={true}
              />
            </div>

            <DateBox
              className="col-sm-2 ms-2"
              label="Emissão"
              stylingMode="outlined"
              onChange={onChangeEmissao}
              value={emissaoValue}
              required={true}
            />

            <TextBox
              className="flex-fill ms-2"
              label="Observação"
              stylingMode="outlined"
              onChange={onChangeObservacao}
              value={observacaoValue}
            />
          </div>

          {ocultarProdutosServicos ? null : (
            <ProdutosServicos className="mb-4" grupoId={grupoId} />
          )}

          <Movimentacoes grupoId={grupoId} grupoEmissao={emissaoValue} />
        </>
      )}
    </div>
  );
};
